import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { InputImage, InputText } from '@goodfynd/react-web.lib.forms';

import type { BasicInfoFormFields } from '../types';

const BasicInfo = ({ control }: UseFormReturn<BasicInfoFormFields>) => {
  return (
    <>
      <InputImage control={control} name="image" />

      <InputText
        control={control}
        label="Organization/Property Name"
        name="organizationName"
      />

      <InputText control={control} label="Event Name" name="eventName" />

      <InputText
        control={control}
        label="Event Description"
        multiline
        name="description"
      />

      <InputText control={control} label="RSVP Website" name="rsvpSite" />
    </>
  );
};

export default BasicInfo;
